export default __webpack_public_path__ + "locales/hy-AM/ChangeUserStatusDialog.json?hash=8f065d7c7aa6615e78cea1b6fdc22b84";